import { Grid, TextField } from '@mui/material';
import { MobileDateRangePicker } from '@mui/lab';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUsers } from '../../../../redux/slices/hrRedux/UserManagementRedux/userManagementRedux';
import { format, startOfDay, endOfDay } from 'date-fns';
import moment from 'moment/moment';
import { getGuestDataForDateRange, getHomeDashboardData } from '../../../../redux/slices/homeRedux/homeRedux';
import { accessVerify } from '../../../../utils/common';

export default function FinanceDataFilter({ data, setData }) {
  const dispatch = useDispatch();
  let saleListData;
  ({ data: saleListData } = useSelector((state) => state.home));
  const [openPicker, setOpenPicker] = useState(false);
  const [dateRange, setDateRange] = useState([startOfDay(new Date()), endOfDay(new Date())]);

  let selectedLocation;
  ({ selectedLocation } = useSelector((state) => state.location));

  useEffect(() => {
    const startDate = moment(dateRange[0]).startOf('day').format('YYYY-MM-DD');
    const endDate = moment(dateRange[1]).endOf('day').format('YYYY-MM-DD');
    dispatch(
      getGuestDataForDateRange({
        fromDate: startDate,
        toDate: endDate
      })
    );
  }, [dateRange, selectedLocation]);

  useEffect(() => {
    dispatch(getUsers());
  }, []);

  useEffect(() => {
    setData(saleListData);
  }, [saleListData]);

  const formatDateRangeDisplay = ([start, end]) => {
    if (!start || !end) return '';
    return `${format(start, 'dd/MM/yyyy')} - ${format(end, 'dd/MM/yyyy')}`;
  };

  return (
    <>
      {accessVerify('DASHBOARD_ANALYTICS_DATE_SELECTION') && (
        <Grid item xs={12} md={6}>
          <MobileDateRangePicker
            open={openPicker}
            onClose={() => setOpenPicker(false)}
            onOpen={() => setOpenPicker(true)}
            value={dateRange}
            onChange={(newValue) => {}}
            onAccept={(newValue) => {
              setDateRange(newValue);
            }}
            renderInput={({ inputRef, inputProps, InputProps }) => (
              <TextField
                ref={inputRef}
                {...inputProps}
                InputProps={{
                  ...InputProps,
                }}
                fullWidth
                label='Select Date Range'
                value={formatDateRangeDisplay(dateRange)}
                onClick={() => setOpenPicker(true)}
                readOnly
              />
            )}
          />
        </Grid>
      )}
      <Grid item xs={12} md={6}>

      </Grid>
    </>
  );
}
